<template>
  <el-form
    v-model="examBasicCheck"
    ref="form"
    size="mini"
    label-position="right"
    label-width="150px"
    class="demo-form-inline"
    :disabled="disabled"
  >
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form-item label="血脂：">
          <el-checkbox-group v-model="examBasicCheck.bloodFat">
            <el-checkbox label="LDL高">LDL高</el-checkbox>
            <el-checkbox label="HDL高">HDL高</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="血糖：">
          <el-input v-model="examBasicCheck.bloodSugar.value" class="small-input">
            <template slot="append">mol/升</template>
          </el-input>
          <el-radio-group v-model="examBasicCheck.bloodSugar.checkTime">
            <el-radio label="空腹">空腹</el-radio>
            <el-radio label="餐后1小时">餐后1小时</el-radio>
            <el-radio label="餐后2小时">餐后2小时</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :sm="24" :md="12">
        <el-form-item label="血压：">
          <el-input v-model="examBasicCheck.bloodPressure">
            <template slot="append">mmHg</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :sm="24" :md="12">
        <el-form-item label="心率：">
          <el-input v-model="examBasicCheck.heartRate">
            <template slot="append">次/分</template>
          </el-input>
        </el-form-item>
      </el-col>

      <el-col :sm="24" :md="12">
        <el-form-item label="腰围：">
          <el-input v-model="examBasicCheck.waistline">
            <template slot="append">cm</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :sm="24" :md="12">
        <el-form-item label="BMI：">
          <el-input v-model="examBasicCheck.bmi"></el-input>
        </el-form-item>
      </el-col>
      <el-col :sm="24" :md="12">
        <el-form-item label="血氧饱和度：">
          <el-input v-model="examBasicCheck.spoz">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item>
          <el-button type="primary" @click="_updateExamBasicCheck" size="medium" class="fullWidth"
          v-show="!disabled"
          :loading="submitting"
            >保存</el-button
          >
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { ExamStatesValue } from "../../utils/constants";
import { Util_updateExamState } from "../../utils/util";
import {
  getExamBasicCheck,
  updateExamBasicCheck,
  updateExamState,
} from "../../api/userExamService";

export default {
  name: "BasicCheck",
  props: {
    examUuid: String,
    disabled: Boolean,
  },
  data() {
    return {
      submitting: false,
      //基础检查
      examBasicCheck: {
        bloodFat: [],
        bloodPressure: "",
        bloodSugar: {
          value:"",
          checkTime: "",
        },
        bmi: 0,
        examUuid: "",
        heartRate: 0,
        spoz: 0,
        waistline: 0,
      },
      model: {
        bloodFat: "",
        bloodPressure: "",
        bloodSugar: "",
        bmi: 0,
        examUuid: "",
        heartRate: 0,
        spoz: 0,
        waistline: 0,
      },
      
    };
  },
  methods: {
    //获取基础问询
    _getExamBasicCheck() {
      getExamBasicCheck(this.examUuid).then((res) => {
        if (res.success) {
          if (res.data[0] ) {
            this.model = res.data[0];
            //将数据转化为合适的格式后，赋值给examBasicCheck (这是前端展示的格式)
            this.examBasicCheck = this.getConvertor(res.data[0]);
          }
        } else {
          this.$message({ message: res.description, type: "error" });
        }
        // console.log("examBasicCheck", this.examBasicCheck);
      });
    },
    //更新基础问询
    _updateExamBasicCheck() {
      //转换格式发送给后端;
      this.model = this.postDataConvertor(this.examBasicCheck);
      this.submitting = true;
      updateExamBasicCheck(this.model)
      .then(
        (res) => {
          this.submitting = false;
          if (res.success) {
            this.$message({ message: res.description, type: "success"});
            //更新检查状态后，重新获取检查信息
            this._updateExamState( ExamStatesValue.BASIC_CHECK_40, this._getExamBasicCheck);
          } else {
            this.$message({
              message: res.description,
              type: "warning",
            });
          }
        }
      ).catch( e=>{
        this.submitting = false;
        console.log(e)
      })
      ;
    },
    //更新检查状态、并重新获取更新的信息
    _updateExamState(state, reloadFunc) {
      //如果已到达，则将其状态改为30:基础问询中
      Util_updateExamState(
        this.examUuid,
        state,
        updateExamState,
        reloadFunc,
        this.$message
      );
    },
    // data with typeof prop's value is string with splitter convert to Array
    getConvertor(data, direction, splitter = "^") {
      // console.log(splitter)
      let convertedData = {
        examUuid: "",
        bloodFat: "",
        bloodPressure: "",
        bloodSugar: "",
        bmi: 0,
        heartRate: 0,
        spoz: 0,
        waistline: 0,
      };
      if (typeof data == "object") {
        for (let key in data) {
          let temp;
          switch (key) {
            case "examUuid":
              convertedData[key] = data[key];
              break;
            case "bloodFat":
              convertedData[key] = data[key].split(splitter)
              break;
            case "bloodPressure":
              convertedData[key] = data[key];
              break;
            case "bloodSugar":
              temp = data[key].split(splitter)
              convertedData[key] = {
                value:temp[0],
                checkTime:temp[1],
              }
              break;
            case "bmi":
              convertedData[key] = data[key];
              break;
            case "heartRate":
              convertedData[key] = data[key];
              break;
            case "spoz":
              convertedData[key] = data[key];
              break;
            case "waistline":
              convertedData[key] = data[key];
              break;
          
          }
        }
        return convertedData;
      } else {
        alert("转换器不能转换非对象");
        return false;
      }
    },
    // data with typeof prop's value is Array convert to string with splitter
    postDataConvertor(data, splitter = "^") {
      console.log(splitter)
      let convertedData = {
        examUuid: "",
        bloodFat: "",
        bloodPressure: "",
        bloodSugar: "",
        bmi: 0,
        heartRate: 0,
        spoz: 0,
        waistline: 0,
      };
      if (typeof data == "object") {
        for (let key in data) {
          switch (key) {
            case "examUuid":
              convertedData[key] = data[key];
              break;
            case "bloodFat":
              convertedData[key] = data[key].join(splitter);
              break;
            case "bloodPressure":
              convertedData[key] = data[key];
              break;
            case "bloodSugar":
              convertedData[key] =
                data[key].value +
                splitter +
                data[key].checkTime;
              break;
            case "bmi":
              convertedData[key] = data[key];
              break;
            case "heartRate":
              convertedData[key] = data[key];
              break;
            case "spoz":
              convertedData[key] = data[key];
              break;
            case "waistline":
              convertedData[key] = data[key];
              break;
          
          }
        }
        return convertedData;
      } else {
        alert("转换器不能转换非对象");
        return false;
      }
    },
    // test two Object is Indentical: (props are basic data types)
    ObectIdenticalTest(obj1, obj2) {
      let flag = true;
      for (let key in obj1) {
        // if(obj1[key] )
        if (obj1[key] != obj2[key]) {
          flag = false;
          return flag;
        }
      }
      for (let key in obj2) {
        if (obj2[key] != obj1[key]) {
          flag = false;
          return flag;
        }
      }
      return flag;
    },

  },
  
  created() {
    this.examBasicCheck.examUuid = this.examUuid;
    this.model.examUuid = this.examUuid;
    this._getExamBasicCheck();
  },
};
</script>

<style scoped>
.small-input {
  width: 150px;
  margin-right:20px;
}
.fullWidth {
  width: 100%;
}

.fr {
  float: right;
}
.fl {
  float: left;
}
</style>
